export default {
  nav: {
    home: "Accueil", casa: "La Maison", camere: "Chambres", gallery: "Galerie",
    dove: "Localisation", cosa: "À Voir", esperienze: "Expériences",
    recensioni: "Avis", contatti: "Contact", prenota: "Réserver",
  },
  hero: {
    eyebrow: "Casa Vacanze Margherita · Santa Croce Camerina, Sicile",
    lines: ["Votre maison en Sicile,", "entre mer, culture", "et liberté."],
    sub: "Découvrez le sud-est de la Sicile en séjournant à Casa Vacanze Margherita — votre point de départ idéal pour explorer la mer, les villages baroques et les merveilles de la côte.",
    cta1: "Découvrir la maison",
    cta2: "Vérifier la disponibilité",
    badges: ["3 chambres", "Jusqu'à 6 personnes", "Wi-Fi rapide", "Climatisation", "3 balcons", "Arrivée autonome"],
    scroll: "Faites défiler",
  },
  welcome: {
    eyebrow: "Bienvenue",
    title: "Bienvenue à Casa Vacanze Margherita",
    p1: "Ouvrez la porte, posez vos valises et commencez à découvrir la Sicile. La mer est à quelques minutes, et certains des plus beaux villages baroques de l'île vous attendent un peu plus loin.",
    p2: "Un appartement de 110 m² au deuxième étage d'un immeuble tranquille : trois chambres, une cuisine qui sent le citron, un salon pour les soirées lentes et trois balcons pour respirer l'air du sud.",
    stats: [{ v: "110", l: "m² de maison" }, { v: "3", l: "chambres" }, { v: "6", l: "personnes max" }, { v: "3", l: "balcons" }],
  },
  comfort: {
    eyebrow: "Les Équipements",
    title: "Chaque détail, pensé pour vos vacances",
    items: [
      { icon: "ChefHat", t: "La cuisine des longs déjeuners", d: "Équipée et lumineuse, avec tout le nécessaire pour cuisiner ensemble les produits du marché — et un balcon à deux pas de la table." },
      { icon: "Tv", t: "Soirées films et séries", d: "Deux Smart TV avec Netflix pour les soirées où vous voulez simplement vous allonger sur le canapé et recharger vos batteries." },
      { icon: "Snowflake", t: "La fraîcheur quand il faut", d: "Climatisation pour bien dormir, même pendant les nuits d'août où la Sicile ne cesse de briller." },
      { icon: "WashingMachine", t: "Des valises plus légères", d: "Machine à laver à disposition : partez avec moins de bagages et restez un jour de plus, si vous voulez." },
      { icon: "Armchair", t: "Trois balcons, trois moments", d: "Le café du matin, le livre de l'après-midi, l'apéritif au coucher du soleil. Chaque balcon a sa bonne heure." },
      { icon: "KeyRound", t: "Arrivez quand vous voulez", d: "Arrivée autonome : pas d'horaires stricts, pas d'attente. Le voyage est à vous, la maison vous attend." },
      { icon: "Car", t: "Parking à proximité", d: "Garez-vous confortablement à quelques pas de la maison et oubliez la voiture jusqu'à la prochaine exploration." },
      { icon: "PawPrint", t: "Vos animaux sont les bienvenus", d: "Chiens et chats voyagent avec vous et se sentent ici comme chez eux. Eux aussi méritent des vacances." },
      { icon: "Gift", t: "Un accueil qui sent la Sicile", d: "Un petit cadeau artisanal vous attend : notre façon de vous dire qu'ici, vous êtes en famille." },
    ],
  },
  seaCulture: {
    eyebrow: "From Sea to Culture",
    title: "Deux mondes, une seule maison",
    motto: "La mer le matin. Un village baroque l'après-midi. Un dîner sicilien le soir.",
    sea: { label: "SEA", title: "La mer à quelques minutes", text: "Plages dorées, couchers de soleil sur la promenade et le phare de Punta Secca qui veille sur la maison de Montalbano.", points: ["Marina di Ragusa", "Punta Secca", "Donnalucata"] },
    culture: { label: "CULTURE", title: "Le baroque au coin de la rue", text: "Pierre dorée, escaliers scénographiques, chocolat et traditions : le Val di Noto est classé à l'UNESCO.", points: ["Scicli", "Modica", "Ragusa Ibla", "Noto"] },
    cta: "Explorer le territoire",
  },
  roomsTeaser: {
    eyebrow: "Les Chambres",
    title: "Trois chambres, chacune avec son caractère",
    text: "Pas des chambres d'hôtel, mais de vraies pièces d'une vraie maison : lumineuses, silencieuses, prêtes pour votre repos.",
    cta: "Découvrir les chambres",
  },
  rooms: {
    matrimoniale: { name: "Chambre Double", beds: "Lit double · 2 couchages", d: "Spacieuse et lumineuse, avec balcon, grande armoire à miroir et le silence qu'il faut pour vraiment dormir.", features: ["Balcon privé", "Climatisation", "Armoire à miroir"] },
    singola: { name: "Chambre Simple", beds: "Lit simple · 1 couchage", d: "Un refuge tranquille et cosy, parfait pour ceux qui voyagent en famille mais aiment leur espace.", features: ["Lumineuse et silencieuse", "Idéale pour les ados"] },
    castello: { name: "Chambre avec Lits Superposés", beds: "Lits superposés · 2 couchages", d: "Les enfants l'adorent, les amis l'apprécient : deux couchages, climatisation et balcon.", features: ["Balcon", "Climatisation", "Parfaite pour les plus petits"] },
  },
  position: {
    eyebrow: "La Localisation",
    title: "Entre la mer et la Sicile que vous voulez découvrir.",
    text: "Casa Vacanze Margherita se trouve à Santa Croce Camerina : la mer à quelques minutes, et d'ici chaque journée peut prendre une direction différente — la côte, les villages, le baroque.",
    note: "Temps de trajet indicatifs en voiture",
    min: "min env.",
    here: "Vous êtes ici",
    cta: "Voir où nous sommes",
  },
  destinations: {
    santacroce: { name: "Santa Croce Camerina", d: "Votre quartier général : un village authentique, avec marchés, boulangeries et la Sicile de tous les jours." },
    puntasecca: { name: "Punta Secca", d: "La maison du Commissaire Montalbano, le phare et une plage qui ressemble à un décor de cinéma." },
    marina: { name: "Marina di Ragusa", d: "Promenade, port de plaisance, restaurants en bord de mer et plages équipées pour toute la famille." },
    donnalucata: { name: "Donnalucata", d: "Un village de pêcheurs aux barques colorées et au marché aux poissons le matin." },
    scicli: { name: "Scicli", d: "Un salon baroque niché entre les carrières : palais, églises et la rue la plus photographiée du sud-est." },
    modica: { name: "Modica", d: "La cathédrale San Giorgio et le chocolat le plus ancien d'Italie, à déguster là où il est né." },
    ragusa: { name: "Ragusa Ibla", d: "Une crèche de pierre dorée : ruelles, jardins et la cathédrale qui domine la vallée." },
    noto: { name: "Noto", d: "La capitale du baroque sicilien : un cours de palais dorés qui s'embrase au coucher du soleil." },
  },
  experiences: {
    eyebrow: "Expériences",
    title: "Ne vous contentez pas de séjourner. Vivez la Sicile.",
    text: "Chaque journée peut être différente : nous vous aidons à choisir, avec les conseils de ceux qui vivent cette terre.",
    more: "Découvrir toutes les expériences",
    items: [
      { id: "mare", t: "Mer", d: "Plages libres et équipées, criques et couchers de soleil sur la promenade." },
      { id: "barocco", t: "Baroque", d: "Scicli, Modica, Ragusa Ibla, Noto : la Sicile classée à l'UNESCO." },
      { id: "enogastronomia", t: "Gastronomie", d: "Chocolat de Modica, granita au petit-déjeuner, poisson frais au dîner." },
      { id: "borghi", t: "Villages", d: "Punta Secca, Donnalucata et les bourgs où le temps ralentit." },
      { id: "famiglia", t: "Famille", d: "Plages sûres, vrais espaces, jeux à la maison : enfants heureux, parents détendus." },
      { id: "natura", t: "Nature", d: "Campagnes d'oliviers et de caroubiers, murets de pierre sèche et réserves en bord de mer." },
      { id: "relax", t: "Détente", d: "Le balcon, un livre, le soleil : les vacances les plus simples qui soient." },
      { id: "cultura", t: "Culture", d: "Céramiques, fêtes de village, musées et les lieux de Montalbano." },
      { id: "escursioni", t: "Excursions", d: "Randonnées côtières, balades à cheval et journées en bateau le long de la côte." },
    ],
  },
  audience: {
    eyebrow: "Parfait Pour",
    title: "Retrouvez-vous dans vos vacances",
    items: [
      { id: "coppie", t: "Couples", d: "Pour une escapade romantique en Sicile, entre couchers de soleil sur la mer et dîners dans les villages." },
      { id: "famiglie", t: "Familles", d: "L'espace et la liberté de se sentir chez soi : jeux, cuisine et plages sûres." },
      { id: "gruppi", t: "Groupes d'amis", d: "Trois chambres et tous les espaces pour vivre les vacances ensemble." },
      { id: "viaggiatori", t: "Voyageurs", d: "La base idéale pour explorer le sud-est de la Sicile, une nouvelle direction chaque jour." },
    ],
  },
  reviews: {
    eyebrow: "Avis",
    title: "Les mots de nos hôtes",
    scoreWord: "Exceptionnel",
    countText: "Basé sur 10 avis vérifiés",
    verified: "Hôte vérifié",
    reviewsWord: "avis",
    mapsLink: "Voir tout sur Google Maps",
    readAll: "Lire tous les avis sur Booking.com",
    cats: { cleanliness: "Propreté", comfort: "Confort", value: "Rapport qualité/prix", staff: "Personnel", facilities: "Équipements", location: "Emplacement" },
    cta: "Tous les avis",
  },
  direct: {
    eyebrow: "Réservation Directe",
    title: "En réservant directement avec nous",
    items: [
      { icon: "MessagesSquare", t: "Assistance directe", d: "Vous parlez avec ceux qui vous accueilleront, sans intermédiaires." },
      { icon: "Smartphone", t: "Communication simple", d: "Un message sur WhatsApp et vous avez la réponse que vous cherchez." },
      { icon: "MapPinned", t: "Conseils personnalisés", d: "Plages, restaurants et villages : nous vous disons ceux que nous aimons." },
      { icon: "CalendarCheck", t: "Flexibilité maximale", d: "Dates, horaires d'arrivée, besoins particuliers : parlons-en ensemble." },
    ],
    cta: "Demander un devis",
  },
  finalCta: {
    title: "La Sicile vous attend.",
    text: "Apportez votre envie de découvrir. Casa Vacanze Margherita s'occupe du reste.",
    cta: "Vérifier la disponibilité",
  },
  footer: {
    tagline: "La Sicile vous attend.",
    explore: "Explorer",
    contacts: "Contact",
    rights: "Tous droits réservés.",
    payoff: "From Sea to Culture",
  },
  form: {
    title: "Vérifier la disponibilité",
    subtitle: "Remplissez le formulaire : nous vous répondrons au plus vite avec la disponibilité et un devis.",
    name: "Nom et prénom",
    email: "E-mail",
    phone: "Téléphone (facultatif)",
    checkin: "Arrivée",
    checkout: "Départ",
    guests: "Voyageurs",
    pets: "Je voyage avec des animaux",
    message: "Message",
    messagePh: "Racontez-nous votre voyage...",
    submit: "Envoyer la demande",
    sending: "Envoi en cours...",
    success: "Demande envoyée ! Nous vous répondrons très vite.",
    error: "Une erreur est survenue. Réessayez ou écrivez-nous sur WhatsApp.",
    whatsapp: "Continuer sur WhatsApp",
    waMsg: "Bonjour, je souhaite recevoir des informations sur Casa Vacanze Margherita pour un séjour",
  },
  contact: {
    title: "Contact",
    heroTitle: "Besoin d'informations ?",
    heroSub: "Écrivez-nous directement : nous répondons personnellement à chaque message.",
    whatsapp: "WhatsApp",
    phone: "Téléphone",
    email: "E-mail",
    where: "Où nous sommes",
    formTitle: "Écrivez-nous",
    send: "Envoyer le message",
    success: "Message envoyé ! Nous vous répondrons bientôt.",
  },
  pages: {
    casa: { eyebrow: "La Maison", title: "Une vraie maison sicilienne, prête à vous accueillir", seo: "La Maison | Casa Vacanze Margherita", desc: "Découvrez l'appartement de 110 m² : 3 chambres, cuisine équipée, salon avec Smart TV, 3 balcons et tout le confort pour vos vacances en Sicile." },
    camere: { eyebrow: "Les Chambres", title: "De vraies chambres, pour un vrai repos", seo: "Chambres | Casa Vacanze Margherita", desc: "Trois chambres lumineuses jusqu'à 6 personnes : double, simple et lits superposés. Maison de vacances à Santa Croce Camerina, Raguse." },
    gallery: { eyebrow: "Galerie", title: "Regardez la maison, imaginez les vacances", seo: "Galerie | Casa Vacanze Margherita", desc: "Les vraies photos de Casa Vacanze Margherita : chambres, cuisine, espaces, détails et le territoire du sud-est de la Sicile." },
    dove: { eyebrow: "Localisation", title: "Entre la mer et la Sicile que vous voulez découvrir.", seo: "Localisation | Casa Vacanze Margherita — Santa Croce Camerina", desc: "Casa Vacanze Margherita est à Santa Croce Camerina (RG) : à quelques minutes de Marina di Ragusa et Punta Secca, base idéale pour Scicli, Modica, Ragusa Ibla et Noto." },
    cosa: { eyebrow: "À Voir", title: "Le sud-est de la Sicile, jour après jour", seo: "À voir | Sud-Est de la Sicile | Casa Vacanze Margherita", desc: "Marina di Ragusa, Punta Secca, Scicli, Modica, Ragusa Ibla, Noto : que voir près de Casa Vacanze Margherita, avec temps de trajet." },
    esperienze: { eyebrow: "Expériences", title: "Ne vous contentez pas de séjourner. Vivez la Sicile.", seo: "Expériences en Sicile | Casa Vacanze Margherita", desc: "Mer, baroque, gastronomie, villages et nature : les expériences à vivre pendant votre séjour à Casa Vacanze Margherita." },
    recensioni: { eyebrow: "Avis", title: "Les mots de nos hôtes", seo: "Avis | Casa Vacanze Margherita", desc: "Ce que disent les hôtes de Casa Vacanze Margherita, maison de vacances à Santa Croce Camerina près de Marina di Ragusa." },
    prenota: { eyebrow: "Réserver", title: "Réservez votre séjour", seo: "Réserver | Casa Vacanze Margherita", desc: "Vérifiez la disponibilité de Casa Vacanze Margherita et réservez directement votre séjour en Sicile." },
  },
  casaPage: {
    p1: "Au deuxième étage d'un immeuble tranquille au cœur de Santa Croce Camerina, Casa Vacanze Margherita est un appartement de 110 m² pensé pour ceux qui cherchent une vraie maison, pas une chambre d'hôtel.",
    p2: "Le style est moderne avec des touches vintage et des détails siciliens : la nappe aux citrons, les carreaux décorés, une mandala dessinée à la main. Chaque coin raconte le soin de ceux qui aiment cette maison.",
    petsTitle: "Vos amis à quatre pattes aussi",
    petsText: "Les animaux sont toujours les bienvenus : emmenez-les avec vous, ils trouveront ici espace et câlins.",
    giftTitle: "Bienvenue à la maison",
    giftText: "À l'arrivée, vous trouverez un petit cadeau artisanal qui sent la Sicile : notre façon de vous souhaiter la bienvenue.",
    faqTitle: "Questions fréquentes",
    faq: [
      { q: "Comment réserver ?", a: "Directement depuis le site avec le formulaire de demande, ou en nous écrivant sur WhatsApp, par e-mail ou par téléphone. Nous vous répondrons avec la disponibilité et un devis." },
      { q: "Combien de personnes la maison accueille-t-elle ?", a: "L'appartement accueille confortablement jusqu'à 6 personnes : parfait pour les familles, les couples et les groupes d'amis." },
      { q: "Les animaux sont-ils admis ?", a: "Oui, vos amis à quatre pattes sont toujours les bienvenus." },
      { q: "Comment fonctionne l'arrivée ?", a: "Avec l'arrivée autonome, vous arrivez à l'heure que vous préférez, sans contrainte d'horaire." },
    ],
  },
  dovePage: {
    howTitle: "Comment arriver",
    car: { t: "En voiture", d: "Depuis Catane, prenez l'A18 vers Raguse puis Santa Croce Camerina (environ 1h45). Depuis l'aéroport de Comiso, la maison est à environ 30 minutes." },
    plane: { t: "En avion", d: "Les aéroports les plus proches sont Comiso (CIY) et Catane (CTA). Depuis l'aéroport, vous pouvez louer une voiture ou réserver un transfert privé." },
    bus: { t: "En bus", d: "Des bus directs partent de Raguse et Comiso vers Santa Croce Camerina, avec un arrêt à quelques pas de la maison." },
    quiet: "La maison se trouve à quelques mètres du centre historique, dans une zone calme et bien desservie.",
  },
};
